export default "__VITE_ASSET__ZtT6Fn$T__"